import type { CustomerLink } from "@/modules/project/ui/customer-links";

// 앱 첫 화면 주소(웹뷰가 처음 여는 곳) · 직원이 로그인하면 가는 「오늘」.
export const START_PATH = "/start";
export const STAFF_HOME_PATH = "/app/today";
// 고객 자동 이동 없이 고르는 화면 — 죽은 링크·다른 공사·직원 로그인으로 빠져나오는 길.
export const START_PICK_HREF = `${START_PATH}?pick=1`;

// ?pick=1 만 고르기로 본다(라우터가 숫자 1 로 풀 수도 있다).
export const startPickOf = (raw: unknown): boolean => raw === 1 || raw === "1";

// 세션이면 직원 「오늘」 · 고르기가 아니고 기억한 고객 연결이 하나면 그 공사 · 아니면 null(고르는 화면).
export const startTargetOf = (signedIn: boolean, links: readonly CustomerLink[], pick = false): string | null => {
  if (signedIn) return STAFF_HOME_PATH;
  return !pick && links.length === 1 ? links[0].path : null;
};
